import { gql } from "@apollo/client";

const CoverStoriesQuery = gql`
  query GetCoverStories($language: String = "en", $size: Int = 15, $offset: Int = 0, $notIn: [ID!] = []) {
    coverStories(
      where: {
        language: $language,
        notIn: $notIn,
        filterCoverStoryByDate: true
        offsetPagination: {
          size: $size
          offset: $offset
        }
      }
    ) {
      pageInfo {
        offsetPagination {
          hasMore
          total
        }
      }
      nodes {
        databaseId
        title
        uri
        gameData {
          gameNumber
          coverStoryDate
        }
      }
    }
  }
`;

export default CoverStoriesQuery;